import { useQueryClient } from "@tanstack/react-query";

import { CompanySummary, Job } from "@/types";

export const useAddOrSetJobInCompanies = () => {
  const queryClient = useQueryClient();

  return ({ job }: { job: Job }) => {
    queryClient.setQueryData(
      ["companies-summary"],
      (cachedData: CompanySummary[] | undefined) => {
        if (!cachedData) return cachedData;

        return cachedData.map((c) => {
          if (c.id === job.companyId) {
            const jobExists = c.jobs.some((j) => j.id === job.id);

            if (jobExists) {
              return {
                ...c,
                jobs: c.jobs.map((j) =>
                  j.id === job.id
                    ? { ...j, title: job.title, status: job.status }
                    : j,
                ),
              };
            }

            const newJobs = [
              {
                id: job.id,
                title: job.title,
                status: job.status,
                stafferAgentActive: false,
              },
              ...c.jobs,
            ];
            newJobs.sort((a, b) => a.title.localeCompare(b.title));

            return {
              ...c,
              jobs: newJobs,
            };
          }

          return c;
        });
      },
    );
  };
};
